export const enum CurrencyType {
  CRYPTO = 'CRYPTO',
  FIAT = 'FIAT'
}
